export const COPY = {
  noWorkType: 'You must select a job type to see available finance rates',
  invalid:
    'There are no rates available for this job given the current price and/or job type selected',
};
